import { render } from "./InputIds.vue?vue&type=template&id=9e7dcd72&ts=true"
import script from "./InputIds.vue?vue&type=script&lang=ts"
export * from "./InputIds.vue?vue&type=script&lang=ts"

import "./InputIds.vue?vue&type=style&index=0&id=9e7dcd72&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__